import { ComplaintCommentDTO } from '../../../../Domain/DTO/ComplaintCommentDTO';
import { VolmaContainer } from '../../../../Infrastructure/InversifyInject';
import { VolmaTableService } from '../../../../Infrastructure/Services/VomaTableService';
import { Types } from '../../../../Infrastructure/Types';
import { BaseValidator } from '../../../../Infrastructure/Validation/BaseValidator';
import { VolmaInputValidator } from '../../../../Infrastructure/Validation/VolmaInputValidatorValidator';
import i18next from '../../../i18n';
import { IVolmaTableColumn } from '../../../Table/VolmaTable/IVolmaTableProps';
import VolmaInput from '../../../VolmaInput/index';
import { IVolmaInputProps } from '../../../VolmaInput/IVolmaInputProps';
import VolmaNumber from '../../../VolmaNumber';
import VolmaSelect from '../../../VolmaSelect/index';
import { BaseEntityService } from '../../BaseEntity/BaseEntityService';
import { IBaseEntityProps } from '../../BaseEntity/IBaseEntityProps';
import { IEntityReducer } from '../../BaseEntity/IEntityReducer';
import { injectable } from 'inversify';
import PropertyHelper from '../../../../Infrastructure/Services/PropertyHelper';
import * as React from 'react';


@injectable()
export class ComplaintCommentEntityService extends BaseEntityService<ComplaintCommentDTO, {}>{
    private _volmaTableService: VolmaTableService;
    private _inputValidator: BaseValidator<IVolmaInputProps>;

    constructor() {
        super();

        this._volmaTableService = VolmaContainer.get<VolmaTableService>(Types.VolmaTableService);
        this._inputValidator = VolmaContainer.get<VolmaInputValidator>(Types.VolmaInputValidator);
    }

    public GetColumnsList(): Array<IVolmaTableColumn> {
        return [];
    }

    public GetHeaderEditor(props: IBaseEntityProps<ComplaintCommentDTO, {}>): JSX.Element {
        return undefined;
    }

    public GetEditorModal(props: IBaseEntityProps<ComplaintCommentDTO, {}>): JSX.Element {
        return this.GetOneCommentEditor(props);
    }

    public GetEditor(props: IBaseEntityProps<ComplaintCommentDTO, {}>): JSX.Element {
        return undefined;
    }

    public InitializeEntity(props: IBaseEntityProps<ComplaintCommentDTO, {}>): void {
        return undefined;
    }

    public OnAfterDataLoaded(dto: ComplaintCommentDTO): void {
        return undefined;
    }

    public GetReducer(): IEntityReducer<ComplaintCommentDTO, {}> {
        return undefined;
    }

    public GetInitialDataHelper(): Object {
        return {};
    }

    private GetOneCommentEditor(props: IBaseEntityProps<ComplaintCommentDTO, {}>): JSX.Element{
        return (
            <div className={(this._mainInfo()).toString()}>
                <div className={(this._titleDropParent).toString()}>
                    {this.GetMainInfoNoTitleItem(true, false, this.OneCommentPart(props))}
                </div>
            </div>
        );
    }

   private OneCommentPart(props: IBaseEntityProps<ComplaintCommentDTO, {}>): JSX.Element{
        return (
            <div className={(this._mainInfo("row")).toString()}>
                <div className={this._mainInfo("cell", { 100: true }).toString()}>
                    <div className={this._mainInfo("line", { fill: true }).toString()}>
                        <VolmaInput
                            {...PropertyHelper.GetInputPropertyByName(props.Inputs, (val: ComplaintCommentDTO) => val.Comment) }
                            Name={PropertyHelper.GetPropertyName((val: ComplaintCommentDTO) => val.Comment)}
                            Type="textarea"
                            Label={i18next.t('complaint:Comment')}
                            Value={props.DataDTO.Comment}
                            Required={true}
                            Validator={this._inputValidator}
                            dispatch={props.dispatch} />
                    </div>
                </div>
            </div>
        );
    }
}